<script setup lang="ts">
import { GroupData } from '~/types/groups'

const props = defineProps<{
  group: GroupData
}>()
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <p class="tw-black/80">
      <span class="tw-font-semibold">{{ props.group.members_count }}</span>
      <span>{{ $t('x-members', props.group.members_count) }}</span>
    </p>
  </div>
</template>
